<template>
  <tk-container
    :status="status"
    @refresh="init"
    class="home-page"
  >
    <div
      slot="header"
      class="home-header"
    >
      <div class="home-header__bar">
        <img
          :src="titleLogo"
          alt="写作训练营标题标识"
          class="home-header__logo"
        >
        <div class="home-header__actions">
          <button
            type="button"
            class="home-header__icon-btn"
            @click="$push('/account/mine')"
          >
            <van-icon name="contact-o" />
          </button>
          <button
            type="button"
            class="home-header__cta"
            @click="$push('/exchange/exchange')"
          >
            <van-icon name="bag-o" />
            <span>兑换课程</span>
          </button>
        </div>
      </div>
      <div
        class="home-header__search"
        @click="$push('/common/search')"
      >
        <van-icon name="search" />
        <span>输入关键词搜索课程，如“童话”“描写”</span>
      </div>
    </div>

    <div class="home-body">
      <div class="home-banner">
        <swipe-card
          v-if="swipeList.length"
          :data="swipeList"
          class="home-banner__swipe"
        />
        <img
          v-else
          :src="bannerImage"
          alt="写作训练营课程主视觉"
          class="home-banner__image"
        >
      </div>

      <div class="home-divider">
        <span class="home-divider__line" />
        <span class="home-divider__dot">
          <span class="home-divider__core" />
        </span>
        <span class="home-divider__line" />
      </div>

      <div
        v-if="courses.length"
        class="home-course-grid"
      >
        <article
          v-for="(course, index) in courses"
          :key="course.objectId || index"
          class="home-course-card"
          @click="goCourse(course)"
        >
          <div class="home-course-card__image-wrap">
            <img
              :src="coverForCourse(course, index)"
              :alt="`${course.title || '课程'}封面`"
              class="home-course-card__image"
            >
            <div
              v-if="myCourseIds.includes(course.objectId)"
              class="home-course-card__tag"
            >
              <my-course-tag />
            </div>
          </div>
          <div class="home-course-card__content">
            <h3 class="home-course-card__title">
              {{ course.title || '该课程不存在' }}
            </h3>
            <p class="home-course-card__subtitle">
              {{ course.introduction || '暂无简介' }}
            </p>
            <span class="home-course-card__price">
              {{ formatPrice(course) }}
            </span>
          </div>
        </article>
      </div>
      <global-empty
        v-else
        word="没有找到相关课程～"
        :top="60"
        :bottom="80"
      />
    </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
import MyCourseTag from '@/components/MyCourseTag.vue'
import bannerImage from '@/assets/home/home-banner.jpg'
import titleLogo from '@/assets/home/home-title-logo.png'
import coverFairy from '@/assets/home/course-fairy.png'
import coverNature from '@/assets/home/course-nature.png'
import coverClassic from '@/assets/home/course-classic.png'
import coverCreative from '@/assets/home/course-creative.png'

const coverFallbacks = [
  coverFairy,
  coverNature,
  coverClassic,
  coverCreative,
]

export default {
  components: {
    MyCourseTag
  },
  data () {
    return {
      status: 'loading',
      courses: [],
      swipeList: [],
      bannerImage,
      titleLogo,
    }
  },
  computed: {
    ...mapState(['myCourseIds'])
  },

  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.status = 'loading'
        await this.searchSwipes()
        await this.fetchCourses()
        this.status = false
      } catch (e) {
        this.status = false
      }
    },
    async searchSwipes () {
      this.swipeList = []
      const list = await this.$tkParse.getList('/classes/rotationChartManagement')
      this.swipeList = Array.isArray(list) ? list : []
    },
    async fetchCourses () {
      const courses = await this.$tkParse.getList('/classes/courseList', {
        params: {
          order: '-weight,-createdAt',
        },
      })
      this.courses = Array.isArray(courses) ? courses : []
    },
    coverForCourse (course, index) {
      if (course && course.coverPicture) {
        return course.coverPicture
      }
      return coverFallbacks[index % coverFallbacks.length]
    },
    courseHours (course) {
      const catalog = course && course.courseCatalog
      if (!catalog || !Array.isArray(catalog.list) || !catalog.list.length) {
        return 0
      }
      if (catalog.type) {
        return catalog.list.reduce((total, section) => {
          if (!section || !Array.isArray(section.list)) {
            return total
          }
          return total + section.list.length
        }, 0)
      }
      const first = catalog.list[0]
      if (first && Array.isArray(first.list)) {
        return first.list.length
      }
      return 0
    },
    formatPrice (course) {
      const price = course && course.price
      const hours = this.courseHours(course)
      const priceLabel = price ? `￥${price}` : '免费'
      if (!hours) {
        return priceLabel
      }
      return `${priceLabel} / ${hours} 课时`
    },
    goCourse (course) {
      this.$push({
        path: '/course/courseDetail',
        query: {
          id: course.objectId || '&&&&&',
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.home-page {
  ::v-deep .tk-container-content {
    min-height: 100%;
    background: linear-gradient(180deg, #E6F1FF 0%, #FFFFFF 48%, #EEF0FF 100%) !important;
  }
  ::v-deep .tk-container-header {
    background: transparent;
  }
}

.home-header {
  padding: 20px 15px 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.home-header__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home-header__logo {
  height: 40px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
}

.home-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.home-header__icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(99, 102, 241, 0.2);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.home-header__cta {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  border-radius: 999px;
  padding: 0 14px;
  border: 1px solid rgba(79, 70, 229, 0.35);
  background: linear-gradient(135deg, #4F46E5 0%, #6366F1 100%);
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.2);
}

.home-header__search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(99, 102, 241, 0.18);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
  color: #5C6C94;
  font-size: 13px;
}

.home-body {
  padding: 0 15px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.home-banner {
  border-radius: 28px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.18);
  box-shadow: 0 10px 28px rgba(99, 102, 241, 0.16);
  aspect-ratio: 16 / 9;
}

.home-banner__swipe {
  display: block;
  width: 100%;
}

.home-banner__image {
  width: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 16 / 9;
}

.home-banner {
  ::v-deep .my-swipe {
    width: 100%;
    border-radius: 28px;
  }
  ::v-deep .van-swipe__track,
  ::v-deep .van-swipe-item {
    border-radius: 28px;
    overflow: hidden;
  }
  ::v-deep .van-swipe__indicators {
    left: 50%;
    transform: translateX(-50%);
    bottom: 14px;
    top: auto;
  }
  ::v-deep .van-swipe__indicator {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(79, 70, 229, 0.6);
  }
  ::v-deep .van-image__img {
    width: 100%;
    display: block;
    object-fit: cover;
    aspect-ratio: 16 / 9;
  }
}

.home-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.home-divider__line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(99, 102, 241, 0), rgba(99, 102, 241, 0.35), rgba(99, 102, 241, 0));
}

.home-divider__dot {
  width: 48px;
  height: 16px;
  border-radius: 999px;
  background: rgba(199, 210, 254, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 4px rgba(79, 70, 229, 0.15);
}

.home-divider__core {
  width: 28px;
  height: 4px;
  border-radius: 999px;
  background: rgba(79, 70, 229, 0.8);
}

.home-course-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px;
}

.home-course-card {
  border-radius: 22px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(148, 163, 246, 0.4);
  box-shadow: 0 12px 24px rgba(99, 102, 241, 0.16);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home-course-card:active {
  transform: scale(0.98);
}

.home-course-card__image-wrap {
  position: relative;
  width: 100%;
}

.home-course-card__image {
  width: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 4 / 3;
}

.home-course-card__tag {
  position: absolute;
  top: 4px;
  right: 6px;
}

.home-course-card__content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-course-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.home-course-card__subtitle {
  font-size: 12px;
  color: #64748B;
  line-height: 1.5;
  min-height: 36px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.home-course-card__price {
  font-size: 13px;
  font-weight: 600;
  color: #F9736B;
}

::v-deep .home-header__icon-btn .van-icon {
  font-size: 18px;
  font-weight: bold;
  color: #4F46E5 !important;
}

::v-deep .home-header__cta .van-icon {
  font-size: 16px;
  color: #FFFFFF !important;
}

::v-deep .home-header__search .van-icon {
  font-size: 18px;
  color: #4C50F5 !important;
}
</style>
